import type { PrizeDistributionData as BasePrizeDistributionData } from '@ps/web-shared-api-types/v1-preview/SwPkrSpinAndGo';
import type { DeepRequired } from 'utility-types';

export enum ModalRoute {
  HowItWorks = '/spinandgo/how-it-works',
  OnboardingTourStart = '/spinandgo/onboarding-tour/start',
  OnboardingTourEnd = '/spinandgo/onboarding-tour/end',
  PrizeDistribution = '/spinandgo/prize-distribution',
  WatchGames = '/spinandgo/watch-games'
}

export enum LocalSettingsPath {
  SpinAndGo = 'poker.spinAndGo'
}

export type LocalSettings =
  | { [key: string]: number }
  | {
      onboardingFinished?: boolean;
      onboardingModalShown?: boolean;
    };

export enum PrizeDistributionModalTabs {
  information = 'information',
  prizes = 'prizes',
  blindLevels = 'blindLevels'
}

export type PrizeDistributionData = DeepRequired<BasePrizeDistributionData>;

export enum OnboardingStep {
  GameTypeSelection,
  GameTile,
  GameInformation,
  HowToPlay,
  LetsPlay
}
